import React, { ReactNode } from 'react';

import { PancakeStack } from '@betterment/samba-react';

import FlowHeader from './FlowHeader';

const FlowStepLayout: React.FC<{ children: ReactNode; exitToPath: string; title: string }> = ({
  children,
  exitToPath,
  title,
}) => {
  return (
    <>
      <PancakeStack.Header
        css={{
          maxWidth: '100%',
          display: 'flex',
          justifyContent: 'center',
          borderBottomStyle: 'solid',
          borderBottomWidth: 'thin',
          borderColor: 'border',
        }}
      >
        <FlowHeader exitToPath={exitToPath} title={title} />
      </PancakeStack.Header>
      <PancakeStack.Main
        css={{
          maxWidth: '100%',
          pt: 'space.400',
        }}
      >
        {children}
      </PancakeStack.Main>
    </>
  );
};

export default FlowStepLayout;
